// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__25sOO","label":"SetPasswdForm_label__2ILxb"};